module.exports = __webpack_public_path__ + "img/de.24910444.svg";